import { styled } from '../../config'
import { Box } from './Box'

export const BlueBox = styled(Box, {
  background: '#5263F4',
  color: '#ffffff',
  fontSize: '12px',
  borderRadius: '4px',
  padding: '10px',
  boxSizing: 'border-box',
  fontFamily: 'sans-serif'
})
